import { number, string, z } from 'zod';

export const emailSchema = z.email();
export const usernameSchema = string().min(1).max(30);
export const bioSchema = string().min(3).max(25);
export const amountSchema = string().regex(/^[0-9]*\.?[0-9]*$/);
export const inviteCodeSchema = string()
  .regex(/^[0-9A-Z]{6}$/)
  .min(6)
  .max(6);

export const slippageSchema = number().min(0).max(100);
export const deadlineSchema = number()
  .min(0)
  .max(1 * 24 * 60);
